import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { UIBulkActions } from "../../../../ui";

import "./_EventPayrollBulkActions.scss";

const EventPayrollBulkActions = ({
  labels,
  selectedCount,
  selectedLabel,
  canAdd,
  isEventCompleted,
  onAttachAndMarkPaid,
  onGeneratePayroll,
  onGiveReward,
  onManualDeduction,
}) => {
  const actions = useMemo(() => {
    if (!canAdd) return [];

    return [
      {
        key: "attach-mark-paid",
        label: labels.bulkActions.attachAndMarkPaid,
        variant: "primary",
        appearance: "outline",
        disabled: !isEventCompleted,
        onClick: onAttachAndMarkPaid,
      },
      {
        key: "generate-payroll",
        label: labels.bulkActions.generatePayroll,
        variant: "primary",
        appearance: "outline",
        onClick: onGeneratePayroll,
      },
      {
        key: "give-reward",
        label: labels.bulkActions.giveReward,
        variant: "success",
        appearance: "outline",
        onClick: onGiveReward,
      },
      {
        key: "manual-deduction",
        label: labels.bulkActions.manualDeduction,
        variant: "destructive",
        appearance: "outline",
        onClick: onManualDeduction,
      },
    ];
  }, [
    canAdd,
    isEventCompleted,
    labels.bulkActions.attachAndMarkPaid,
    labels.bulkActions.generatePayroll,
    labels.bulkActions.giveReward,
    labels.bulkActions.manualDeduction,
    onAttachAndMarkPaid,
    onGeneratePayroll,
    onGiveReward,
    onManualDeduction,
  ]);

  return (
    <UIBulkActions
      actions={actions}
      menuItems={[]}
      selectedCount={selectedCount}
      selectedLabel={selectedLabel}
      className="event-payroll__bulk-actions"
    />
  );
};

EventPayrollBulkActions.propTypes = {
  labels: PropTypes.shape({
    bulkActions: PropTypes.object.isRequired,
  }).isRequired,
  selectedCount: PropTypes.number.isRequired,
  selectedLabel: PropTypes.node.isRequired,
  canAdd: PropTypes.bool,
  isEventCompleted: PropTypes.bool,
  onAttachAndMarkPaid: PropTypes.func,
  onGeneratePayroll: PropTypes.func,
  onGiveReward: PropTypes.func,
  onManualDeduction: PropTypes.func,
};

EventPayrollBulkActions.defaultProps = {
  canAdd: true,
  isEventCompleted: false,
  onAttachAndMarkPaid: undefined,
  onGeneratePayroll: undefined,
  onGiveReward: undefined,
  onManualDeduction: undefined,
};

export default EventPayrollBulkActions;
